export default __webpack_public_path__ + "static/media/footer.46ce646b.jpg";